import { render, staticRenderFns } from "./ChargebacksList.vue?vue&type=template&id=58df362b"
import script from "./ChargebacksList.vue?vue&type=script&lang=js"
export * from "./ChargebacksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports